import { render, staticRenderFns } from "./payRequestCard.vue?vue&type=template&id=ef17a5cc&scoped=true"
import script from "./payRequestCard.vue?vue&type=script&lang=js"
export * from "./payRequestCard.vue?vue&type=script&lang=js"
import style0 from "./payRequestCard.vue?vue&type=style&index=0&id=ef17a5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef17a5cc",
  null
  
)

export default component.exports